import React, { FC } from 'react'

import { SignUpStates } from 'Hooks/checkout'
import { Inquiry } from 'Utils/inquiry'

import Details from '../Details'
import Password from '../Password'

interface Props {
  showDetails: boolean
  state: Inquiry<SignUpStates>
}

const Identify: FC<Props> = ({ showDetails, state }) => {
  const activeSection = state.isPassword ? 'password' : 'details'
  let activeSectionTitle: string | null = null
  let activeSectionDescription: string | null = null

  if (state.isPassword) {
    activeSectionTitle = 'Welcome Back'
    activeSectionDescription = 'Sign in to continue with your saved customer profile'
  } else if (showDetails) {
    activeSectionTitle = 'Contact Details'
    activeSectionDescription = 'Add your contact details to continue checkout'
  }

  return (
    <section className="checkout-contact-flow__panel checkout-contact-flow__panel--active" data-step={activeSection}>
      {activeSectionTitle ? <h3 className="checkout-contact-flow__title">{activeSectionTitle}</h3> : null}
      {activeSectionDescription ? (
        <p className="checkout-contact-flow__description mb-2">{activeSectionDescription}</p>
      ) : null}

      {showDetails ? <Details state={state} /> : null}
      {state.isPassword ? <Password /> : null}
    </section>
  )
}

export default Identify
